 <div class="ui  vertical basic segment" appMargin marginT="0" [ngClass]="{'loading': pending }">
  	        <sui-message class="success" *ngIf="success">
	  	  <div class="header">
			{{success}}
		</div>
		</sui-message>
		<sui-message class="warning" *ngIf="error">
				<div class="header">
			{{error | json}}
			</div>
		</sui-message>
    <div class="ui  segment"  fxLayout="row" *ngFor="let config of configs">
        <div fxFlex="grow"  >
            {{config?.appConfigId}}
        <!-- <p appMargin marginB="5">Please enter your current password to change your password</p> -->

        </div>
          <div fxFlex="25%"  >
          	 <sui-checkbox [(ngModel)]="config.appConfigValue" class="toggle" (checkChange)="toggle($event,config)">
                   {{config?.appConfigValue == true?'Enabled':'Disabled'}}
               </sui-checkbox>
        </div>
	</div>

</div>
